import { lazy } from 'react'

export const IdealWeightFeedbackV1 = lazy(
  () => import('./IdealWeightFeedbackV1'),
)
